import React from 'react';
import styles from '../styles/components/services.module.css';
import globalStyles from '../styles/global.module.css';

const OurServicesSection = () => {
  return (
    <div className={styles.servicesSection}>
      <h2 className={styles.servicesTitle}>Our services</h2>
      <div className={`${globalStyles.container} ${styles.servicesRow}`}>
        <a 
          className={styles.serviceCard} 
          href="https://ipgeorgia.ge/bsreg" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <span className={styles.serviceLink}>
            Business Registration/Individual Entrepreneur/Legal Services/Accounting/Office Management
          </span>
        </a>
        <a 
          className={styles.serviceCard} 
          href="https://ipgeorgia.ge/rp" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <span className={styles.serviceLink}>
            Residence permit
          </span>
        </a>
      </div>
    </div>
  );
};

export default OurServicesSection; 